import { useAddSpaceModal } from "@circle-react/components/Modals/AddSpaceModal";
import { canCreateSpaces } from "@circle-react/helpers/spaceGroupHelpers";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";

import type { SpaceGroupWithSpaces } from "../../Sidebar";
import { SidebarItem } from "../SidebarItem";

export interface EmptySpaceListActionProps {
  spaceGroup: SpaceGroupWithSpaces;
}

export const EmptySpaceListAction = ({
  spaceGroup,
}: EmptySpaceListActionProps) => {
  const spaceModal = useAddSpaceModal();
  const navigate = useNavigate();

  if (canCreateSpaces({ spaceGroup })) {
    return (
      <SidebarItem
        data-testid="add-space"
        onClick={() => void spaceModal.show({ spaceGroupId: spaceGroup.id })}
      >
        <SidebarItem.Content label={t("add_space")} startIcon="plus" />
      </SidebarItem>
    );
  }

  if (spaceGroup.hide_non_member_spaces_from_sidebar) {
    return (
      <SidebarItem
        onClick={() =>
          void navigate({
            to: `/s/$spaceGroupSlug`,
            params: { spaceGroupSlug: spaceGroup.slug },
          })
        }
      >
        <SidebarItem.Content label={t("join_a_space")} startIcon="plus" />
      </SidebarItem>
    );
  }

  return null;
};
